export enum routeNames {
	unauthorized = 'unauthorized',
	register = 'register',
	dashboard = 'dashboard',
	campaigns = 'campaigns',
	createCampaign = 'createCampaign',
	campaignDetails = 'campaignDetails',
	campaignMessage = 'campaignMessage',
	campaignResponses = 'campaignResponses',
	campaignResults = 'campaignResults',
	phoneNumberDetails = 'phoneNumberDetails',
	userProfile = 'userProfile',
	landing = 'landing',
	settings = 'settings',
	twilioCallback = 'twilioCallback',
	termsAndConditions = 'termsAndConditions',
}